import { createDirectReportsBreadcrumbsContext } from "@/components/shared/DirectReportsBreadcrumbsContext";
import {
  ConversionRatesDirectReportsResponse,
  ReportType,
  SettingsPeriod
} from "@/entities/reporting/types";

const { BreadcrumbsProvider, useBreadcrumbs } =
  createDirectReportsBreadcrumbsContext<ConversionRatesDirectReportsResponse>({
    reportType: ReportType.CONVERSION_RATES,
    // TODO: make this enum/generic
    responseKey: "conversionRates",
    defaultPeriod: SettingsPeriod.ALL_TIMES,
    getUserIds: (data) => data?.directReports?.map((dr: any) => dr.id) || []
  });

export const ConversionBreadcrumbsProvider = BreadcrumbsProvider;
export const useConversionBreadcrumbs = useBreadcrumbs;
